export const lightenColor = (color: string, percent: number) => {
    if (color.toUpperCase() === "#FFFFFF") {
      if(percent == 1)
        return "#D3D3D3"; // Return a light gray color when the color is white
      else  
        return "#ebe7e7";
    }
    if (!color.startsWith("#")) return color; // Ensure it's a valid hex color
  
    let num = parseInt(color.slice(1), 16),
      amt = Math.round(2.55 * percent),
      r = (num >> 16) + amt,
      g = ((num >> 8) & 0x00ff) + amt,
      b = (num & 0x0000ff) + amt;
  
    return `rgb(${Math.min(r, 255)}, ${Math.min(g, 255)}, ${Math.min(b, 255)})`;
  };